import { Api } from "../axios-config";

export interface IContent {
    _id: string;
    Name: string;
}

export interface IContentId {
   ContentId: string;
}

export interface IContentIds {
    data: IContentId[];
}

export interface IContents {
    data: IContent[];
}



const getAllContents = async (): Promise<IContents | Error> => {
    try {
        const { data } = await Api.get('/contents');
        if (data) {
            const adaptedData = Array.isArray(data) ? data : [];
            return { data: adaptedData };
        } else {
            return new Error('Erro ao listar conteúdos');
        }
    } catch (error) {
        return new Error(`Error getting all contents: ${error}`);
    }
}

const getContentById = async (id: string): Promise<IContent | Error> => {
    try {
        const response = await Api.get(`/contents/${id}`);
        return response.data;
    } catch (error) {
        return new Error(`Error getting content by id: ${error}`);
    }
}

const getAllCotentsInCourseByCourseId = async (courseId: string): Promise<IContent[] | Error> => {
    try {
        const response = await Api.get(`/contents/course/${courseId}`);
        return response.data;
    } catch (error) {
        return new Error(`Error getting all contents in course by course id: ${error}`);
    }
}

const createContent = async (Name: string): Promise<IContent | Error> => {
    try {
        const response = await Api.post('/contents', { Name });
        return response.data;
    } catch (error) {
        return new Error(`Error creating content: ${error}`);
    }
}

const updateContent = async (id: string, Name: string): Promise<IContent | Error> => {
    try {
        const response = await Api.put(`/contents/${id}`, { Name });
        return response.data;
    } catch (error) {
        return new Error(`Error updating content: ${error}`);
    }
}

const deleteContent = async (id: string): Promise<{ message: string } | Error> => {
    try {
        const response = await Api.delete(`/contents/${id}`);
        return response.data;
    } catch (error) {
        return new Error(`Error deleting content: ${error}`);
    }
}

const searchContents = async (search: string): Promise<IContents | Error> => {
    try {
        const response = await Api.get('/contents', {
            params: { name: search }
        });
        if (response.data) {
            const adaptedData = Array.isArray(response.data) ? response.data : [];
            return { data: adaptedData };
        } else {
            return new Error('Erro ao buscar conteúdos');
        }
    } catch (error) {
        return new Error(`Error searching contents: ${error}`);
    }
}

export const ContentsServices = {
    getAllContents,
    getContentById,
    getAllCotentsInCourseByCourseId,
    createContent,
    updateContent,
    deleteContent,
    searchContents
};

